module.exports = __webpack_public_path__ + "media/country_flags/ph-5fcf7924.png";